import * as am5 from '@amcharts/amcharts5';

import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { appRoutes } from './app.routes';
import { URLS } from '../environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    MAT_SELECT_SCROLL_STRATEGY,
    MatSelectModule,
} from '@angular/material/select';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { OPTIMIZELY_CONFIG } from '@dat/iq-proxy';
import { environmentVariables } from '../config/environment.variables';
import { DatiqAppConfig } from '@dat/datiq-core/models';
import { AUTH_CONFIG, PageMode } from '@dat/angular-auth';
import {
    TRACKING_SEGMENT_KEY,
} from '@dat/iq-tracking';

am5.addLicense('AM5C250161689');
am5.addLicense('AM5M348920438');

export const appConfig: ApplicationConfig = {
    providers: [
        URLS,
        provideRouter(appRoutes, withComponentInputBinding()),
        importProvidersFrom(StoreModule.forRoot({})),
        importProvidersFrom(BrowserAnimationsModule),
        importProvidersFrom(OverlayModule),
        importProvidersFrom(MatSelectModule),
        provideHttpClient(withFetch()),
        {
            provide: MAT_SELECT_SCROLL_STRATEGY,
            useFactory: (overlay: Overlay) => () =>
                overlay.scrollStrategies.reposition(),
            deps: [Overlay],
        },
        {
            provide: DatiqAppConfig,
            useValue: {
                analyticsConfig: null,
                environment: environmentVariables.ENVIRONMENT,
                googleApiKey: environmentVariables.GOOGLE_MAPS_KEY,
                headers: {
                    'x-dat-deployment': environmentVariables.X_DAT_DEPLOYMENT,
                },
                dbConfig: {},
                links: [],
                userLinks: [],
                useMock: false,
                coreConfig: {
                    GRAPHQL_URL: environmentVariables.GRAPHQL_URL,
                    GRAPHQL_URL_ONE: environmentVariables.GRAPHQL_URL_ONE,
                    mockGraphQl: false, //Turn this to true if using the mock client
                    ANALYTICS_BASE_URL: environmentVariables.ANALYTICS_BASE_URL,
                    CACHE_BREAKER_QUERY: environmentVariables.CACHE_BREAKER_QUERY,
                    IQ_BASE_URL: environmentVariables.IQ_BASE_URL,
                },
                currentRoute: { path: '', params: {} },
                optimizelyConfig: { ...environmentVariables.OPTIMIZELY_CONFIG },
            },
        },
        {
            provide: AUTH_CONFIG,
            useFactory: function () {
                return {
                    appName: 'IQ',
                    apiBaseUrl: 'https://example.com',
                    pageMode: PageMode.LEGACY,
                    loginIfApiCallNotAuthorized: false,
                    extendedApiTargetedDomains: [],
                    oAuth2Config: {
                        clientId: '',
                        clientDomain: '',
                        audience: '',
                    },
                };
            },
        },
        {
            provide: TRACKING_SEGMENT_KEY,
            useValue: environmentVariables.SEGMENT_KEY,
        },
    ],
};
